<h3 mat-dialog-title style="padding-right: 10px;" translate>
    <span *ngIf = "callbyAttendanceComponet == false">Attendance Code </span> Legend
</h3>
<mat-dialog-content style="max-height: none !important">
    <table mat-table [dataSource]="attendanceCodes" class="mat-elevation-z0" *ngIf = "callbyAttendanceComponet == false">

        <!-- Code Column -->
        <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef style="padding: 20px;text-align: center;" ><span translate>Code</span></th>
            <td mat-cell *matCellDef="let element" style="padding: 20px;text-align: center;">{{element.Code}}</td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef><span translate>Description</span></th>
            <td mat-cell *matCellDef="let element">{{element.Description}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div *ngIf="callbyAttendanceComponet == true">
        <span>A red asterisk (<span style="color: red;">*</span>) identifies codes that will not count as an absences or
        tardy on the report card, but indicate the student was not in class.</span>
   </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>
  </div>
  <div class='flex-footer-right'>
    <tyl-button  id="closeButton" image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
  </div>
</mat-dialog-actions>

